/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 */
import * as types from "./types";

const mutations = {
  [types.SET_ACTIVE_COMPONENT](state, payload) {
    state.activeComponent = payload;
  },
  [types.SET_PREVIOUS_COMPONENT](state, payload) {
    state.previousComponent = payload;
  },
  [types.SET_LAST_COMPONENT_SWATCH_APPLIED](state, payload) {
    state.lastComponentSwatchApplied = payload;
  },
  [types.CREATE_MENU_ITEM](state, {componentName, componentData}) {
    state.menu = {
      ...state.menu,
      [componentName]: componentData
    };
  },
  [types.CHANGE_MENU_ITEM_VISIBILITY](state, { componentName, visible }) {
    if (state.menu[componentName]) {
      state.menu = {
        ...state.menu,
        [componentName]: {
          ...state.menu[componentName],
          visible
        }
      };
    }
  },
  [types.UPDATE_MENU_ITEM_STATE](state, { componentName, itemState = true }){
    state.menu = {
      ...state.menu,
      [componentName]: {
        ...state.menu[componentName],
        item_state: itemState
      }
    };
  },
  [types.CLEAR_MENU](state) {
    state.menu = {};
  },
};

export default mutations;
